import { httpArg, httpPost, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

@httpRoute('/api/user-metadata')
export abstract class IUserMetadataService {
	@httpPost('set-timezone')
	setTimezone(
		@httpUserId() userId: string,
		@httpArg('timezone') timezone: string
	): Promise<void> {
		void userId;
		void timezone;
		throw new Error('Not implemented');
	}
}
